<template>
    <div class="deviceElement">
    <div class="deviceBox">
        <div class="boxContent d-flex flex-column align-items-center">
            <div class="currentBox d-flex justify-content-between align-items-center w-100">
                <div v-if="!showCurrentInput" @click="openCurrentInput">
                    {{editDevice.current}} mA <a v-if="isChangeable"><b><i class="fa-kit fa-beg-gear"></i></b></a>
                </div>
                <div v-if="showCurrentInput" class="d-flex align-items-center">
                    <input @blur="closeCurrentInput" v-model="editDevice.current" class="form-control-sm" /><a @click="closeCurrentInput"><i class="fa-kit fa-beg-check"></i></a>
                </div>
              <a class="deleteBox" v-if="isRemovable" @click="remove">
                <i class="fa-kit fa-beg-trash fa-2x"></i>
              </a>

            </div>
            <div class="imageBox" >
                <template v-if="!device.productNo" >                   
                    <span v-if="device.typeCategory == 1" class="faIcon">
                        <i class="fa-kit fa-interior-light fa-10x"></i>
                        <!-- <img class="iconHeight" :src="imagePath+'/gluehbirne_icon_2.svg'" /> -->
                    </span>
                    <span v-if="device.typeCategory == 2" class="faIcon">
                        <i class="fa-kit fa-pd4 fa-10x"></i>
                        <!-- <img class="iconHeight" :src="imagePath+'/Multisensor.svg'" /> -->
                    </span>
                    <span v-if="device.typeCategory == 3" class="faIcon">
                        <i class="fa-kit fa-beg-pbm fa-10x"></i>
                    </span>
                    <span v-if="device.typeCategory == 4" class="faIcon">
                        <i class="fa-kit fa-relais fa-10x"></i>
                        <!-- <img class="iconHeight" :src="imagePath+'/Relais-01.svg'" /> -->
                    </span>
                </template>
                <img class="realImage" v-if="device.productNo" :src="getImage" />
            </div>
            <div class="deviceNamePosition">
                <b>{{device.name}}</b>
            </div>
        </div>
    </div>
    <div class="deviceAction">
        <div class="form-group">
            <label>{{ $t('general.amount') }}</label>
            <input :disabled="!isChangeable" @click="focusInput" :class="getBgColor" ref="editDeviceAmount" @change="save" @keyup="save" type="number" v-model="editDevice.amount" min="0" class="form-input" />
        </div>
    </div>

</div>
</template>

<script>
/* import BusDeviceTypeDropdown from './BusDeviceTypeDropdown.vue' */
import helper from './../../assets/js/helperTool.js'
import { mapGetters } from 'vuex';

export default {
    name: "BusDeviceCard",
    emits: ['onRemove','saveDevice'],
    data() {
        return {
            showEditBody: false,
            showEditHeader: false,
            showEditFooter: false,
            editDevice: null,
            brandNew: false,
            showCurrentInput: false
        }
    },
    created() {
        this.editDevice = this.device;
        if(this.device.name == "") {
            this.openEdit();
            this.$nextTick(() => {
                this.$refs.nameInput.focus()
            });
        }
    },
    methods: {
        openEdit() {
            this.editDevice = helper.cloneItem(this.device);
            this.showEditBody = true;
        },
        closeAndSave() {
            this.save();
            this.showEditBody = false;
        },
        save() {
            if(this.editDevice.amount < 0) {
                this.editDevice.amount = 0
            }
            if(typeof this.editDevice.amount === 'string') {
                return
            }
            this.editDevice.amount = Math.round( this.editDevice.amount)
            this.$emit('saveDevice', this.editDevice);
        },
        typeChange(type) {
            this.editDevice.typeCategory = type;
        },
        remove() {
            this.$emit('onRemove')
            this.$store.dispatch('busDevice/removeDevice', this.device)
        },
        openCurrentInput() {
            if(!this.isChangeable) {
                return
            }
            this.editDevice = helper.cloneItem(this.device);
            this.showCurrentInput = true;
        },
        closeCurrentInput() {
            this.showCurrentInput = false;
            console.log(this.editDevice.current)
            if(typeof this.editDevice.current === 'string') {
                this.editDevice.current = this.editDevice.current.replace(',','.')
            }
            this.$emit('saveDevice', this.editDevice);
        },
        focusInput(element) {
            element.target.select()
        }
    },
    computed: {
        ...mapGetters({
            slectedController: 'product/getSelectedApplicationController',
            imagePath: 'app/getImagePath'
        }),
        isSensorAllowed() {
            if(this.slectedController.slaveSensorTechnologie !== null) {
                return true;
            } else {
                return false
            }
        },
        isInputDeviceAllowed() {
            if(this.slectedController.slaveInputTechnologie !== null) {
                return true;
            } else {
                return false
            }
        },
        getImage() {
            return this.imagePath+"productImages/"+this.device.productNo+".png"
        },
        getBgColor() {
            if(!this.isChangeable) {
                return "bg-lightGrey text-muted"
            }
            return ""
        }
    },
    props: {
        device: Object,
        isRemovable: {
            type: Boolean,
            default: true
        },
        isChangeable: Boolean
    },
    components: {
/*         BusDeviceTypeDropdown */
    }
}
</script>

<style lang="scss" scoped>
    .imageBox>.faIcon {
      --fa-icon-size: 10rem;
    }

    .deleteBox {
      cursor: pointer;
    }
</style>